import { Component } from '@angular/core';

@Component({
  selector: 'app-noaccess',
  standalone: true,
  imports: [],
  templateUrl: './noaccess.component.html',
  styleUrl: './noaccess.component.css'
})
export class NoaccessComponent {
}
